import styled from 'styled-components'
import { theme } from '@/client/components'
const { color } = theme

export const BlogAuthorWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
`
export const BlogAuthorSingle = styled.a`
  display: flex;
  align-items: center;
  &:hover {
    text-decoration: none;
  }
`
export const Photo = styled.div`
  display: flex;
  width: 143px;
  height: 143px;
  background: ${color.grayscale.dark};
  border-radius: 200px;
  overflow: hidden;
  margin-right: 10px;
`
export const Name = styled.div`
  width: 100%;
`
export const Designation = styled.div`
  width: 100%;
`
export const Details = styled.div``
